import axios from 'axios';

const axiosInstance = axios.create({
  // baseURL: "http://192.168.1.16:8085",
  baseURL: 'https://api_vlsx.tinvietsoft.com', // https3
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.response.use(
    response => response,
    error => {
        console.error('Error:', error);
        return Promise.reject(error);
    },
);

axiosInstance.interceptors.request.use(
    response => response,
    (error) => {
        console.error('Error:', error);
        return Promise.reject(error);
    }
)

export default axiosInstance;